<template>
  <span>
    <label class="page-label label-title">{{
      $t('message.pages.live.liveName')
    }}</label>
    <v-text-field
      ref="title"
      v-model="video.title"
      :rules="[rules().required, rules().max, rules().min]"
      :placeholder="$t('message.addTitle')"
      :class="{ inputActive: 'title' === activeInput }"
      required
      outlined
      dense
      hide-details
      @blur="handleEdit"
      @focus="inputBeingEdited('title')"
    >
      <template v-slot:append>
        <!-- cancel -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="cancelEdit">
              mdi-close
            </v-icon>
          </template>
          <span>
            {{ $t('message.pages.video.cancel') }}
          </span>
        </v-tooltip>

        <!-- save -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="!videoId"
              v-bind="attrs"
              v-on="on"
              @click="handleSaveName"
            >
              mdi-check
            </v-icon>
            <v-icon v-else v-bind="attrs" v-on="on" @click="handleEdit">
              mdi-check
            </v-icon>
          </template>
          <span>
            {{ $t('message.pages.video.save') }}
          </span>
        </v-tooltip>
      </template>
    </v-text-field>
  </span>
</template>

<script>
// API
import VideosAPI from '@/services/videosApi'

// Components

export default {
  name: 'LiveName',
  inject: ['handleSaveName'],
  props: {
    propsData: {
      type: Object,
      required: true,
    },
    liveTitle: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    networkErrorMsg: '',
    activeInput: '',
  }),
  computed: {
    video: {
      get() {
        return this.propsData['video']
      },
      set(value) {
        this.propsData['video'] = value
      },
    },
    videoId: {
      get() {
        return this.propsData['videoId']
      },
      set(value) {
        this.propsData['videoId'] = value
      },
    },
    errors: {
      get() {
        return this.propsData['errors']
      },
      set(value) {
        this.propsData['errors'] = value
      },
    },
    oldVideo: {
      get() {
        return this.propsData['oldVideo']
      },
      set(value) {
        this.propsData['oldVideo'] = value
      },
    },
    // ...
  },
  methods: {
    rules() {
      const i18n = this.$i18next

      return {
        required: (v) => (v && !!v) || i18n.t('message.requiredField'),
        max: (v) =>
          (v && v.length <= 255) || i18n.t('message.maximumLengthVideo'),
        min: (v) => v.length >= 3 || i18n.t('message.pages.live.titleLimit'),
      }
    },
    inputBeingEdited(i, ref) {
      this.activeInput = `${i}${ref ? ref : ''}`
    },
    async handleEdit() {
      this.errors.failedToUpdateVideo = false
      this.networkErrorMsg = ''
      this.activeInput = ''

      const videoObj = {}
      let toReturn = true

      for (const iterator of ['title']) {
        if (this.video[iterator] !== this.oldVideo[iterator]) {
          toReturn = false
          videoObj[iterator] = this.video[iterator].trim()
        }
      }

      if (toReturn) return
      if (this.videoId) {
        try {
          const { data } = await VideosAPI.updateVideo(
            { ...videoObj },
            this.videoId
          )
          let actionToEmit = 'rootEditVideo'

          await window.db.videos.update(data.id, { title: data.title })

          Object.keys(this.oldVideo).forEach((key) => {
            this.$delete(key, this.oldVideo)
          })

          // set `oldVideo` (reactivity)
          Object.keys(data).forEach((key) => {
            this.$set(this.oldVideo, key, data[key])
          })

          // check emit action
          if (this.video.folder_id) actionToEmit = 'folderEditVideo'

          this.$root.$emit(actionToEmit, data)
        } catch (e) {
          this.networkErrorMsg = e.response.data.errMsg
          this.errors.failedToUpdateVideo = true
        }
      }
    },
    cancelEdit() {
      for (const iterator of ['title']) {
        if (this.video[iterator] !== this.oldVideo[iterator]) {
          this.$refs.title.blur()
          this.video[iterator] = this.oldVideo[iterator].trim()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  @import '@/assets/scss/src/new-live';

  .v-text-field fieldset,
  .v-text-field .v-input__control {
    border-color: var(--v-neutral-lighten2);
    color: var(--v-neutral-base);
  }

  &::v-deep {
    @import '@/assets/scss/src/new-live';
  }

  .v-input:not(.inputActive) .v-input__append-inner {
    display: none;
  }
}

.bg-dark {
  .page-label {
    color: var(--v-primary-base) !important;
  }
}
</style>
